export default __webpack_public_path__ + "static/media/fax_icon_active.88de0473.svg";